import { render, staticRenderFns } from "./chats-render.vue?vue&type=template&id=66e4c073"
import script from "./chats-render.vue?vue&type=script&lang=js"
export * from "./chats-render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports